<template lang="pug">
.card-inteligencia-territorial-dados-gerais-imoveis
    .card-inteligencia-territorial-imoveis-interno--texto
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 40%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.car') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo(v-if='informacoesCar.codigo') {{ informacoesCar.codigo }}
                span.conteudo-informativo(v-else) -
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 20%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.nomeDoImovel') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo -
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 15%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.proprietario') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo -
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 15%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.municipio') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo(
                    v-if='informacoesCar.nomeMunicipio'
                ) {{ informacoesCar.nomeMunicipio }}
                span.conteudo-informativo(v-else) -
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 8%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.areaHa') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo(v-if='informacoesCar.areaHa') {{ formatoNumero(informacoesCar.areaHa) }}
                span.conteudo-informativo(v-else) -
</template>
<script>
import formatters from '@/utils/formatters';
export default {
    name: 'CardInteligenciaTerritorialDadosGeraisImovel',
    props: {
        informacoesCar: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {};
    },

    methods: {
        formatoNumero(number) {
            return formatters.formatNumber(number, 2);
        }
    }
};
</script>
<style lang="scss" scoped>
.card-inteligencia-territorial-dados-gerais-imoveis {
    height: 90px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;

    .card-inteligencia-territorial-imoveis-interno--titulo {
        padding-top: 0px;
        font-size: 16px;
        font-weight: 500;
        flex-wrap: wrap;
        margin-top: 14px;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: var(--primary)
    }

    .card-inteligencia-territorial-imoveis-interno--texto {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        min-height: 77px;
        margin-left: 12px;
        width: 100%;
        color: #3B3B3B;

        span {
            margin-top: 6px;
        }
    }

    .card-inteligencia-territorial-imoveis-interno--valor {
        display: flex;
        padding-top: 1px;
        margin-bottom: 5%;
    }

    .conteudo-informativo {
        font-size: 17px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        color: var(--primary);
    }
}
</style>
